import { apiUrls } from '../../constants/apiUrls';
import { handlePromise } from '../helpers';

export const fetchCompanyProfile = async () => {
  const apiPayload = {
    method: 'GET',
    url: apiUrls.fetchCompanyProfileAPI
  };

  return handlePromise(apiPayload);
};

export const getVendorDetails = async (params) => {
  const apiPayload = {
    method: 'GET',
    params,
    url: apiUrls.getVendorDetails
  };

  return handlePromise(apiPayload);
};
